const KEY_DEMO_PROJECT = 'demo_project';
const KEY_SHOULD_BLOCK_ACCESS = 'sba';
const DEMO_PARAM = 'demoModalExample';

// The 8 current tool slugs, in step order
const TOOL_SLUGS = [
  'value-proposition',
  'competition-map',
  'stakeholder-map',
  'business-model-marketing',
  'pricing-business-viability',
  'financial-forecast',
  'impact-plan',
  'growth-plan',
];

export { DEMO_PARAM, KEY_DEMO_PROJECT, KEY_SHOULD_BLOCK_ACCESS, TOOL_SLUGS };
